import React from "react";
import { Box, Typography, keyframes } from "@mui/material";
import { useTranslation } from "react-i18next";
import { buildTypingLabel } from "../utils/teamTypingLabels";

const typingBounce = keyframes`
  0%, 60%, 100% {
    transform: translateY(0);
    opacity: 0.35;
  }
  30% {
    transform: translateY(-3px);
    opacity: 1;
  }
`;

const TeamTypingIndicator = ({ typingUsers = [], compact = false }) => {
  const { t } = useTranslation("team");

  if (!typingUsers?.length) return null;

  return (
    <Box
      sx={{
        px: compact ? 1 : { xs: 1.25, sm: 2 },
        py: 0.5,
        flexShrink: 0,
        display: "flex",
        alignItems: "center",
        gap: 0.75,
        minHeight: 24,
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center", gap: 0.35, height: 14 }}>
        {[0, 1, 2].map((index) => (
          <Box
            key={index}
            sx={{
              width: 5,
              height: 5,
              borderRadius: "50%",
              bgcolor: "text.secondary",
              animation: `${typingBounce} 1.2s ease-in-out infinite`,
              animationDelay: `${index * 0.15}s`,
            }}
          />
        ))}
      </Box>
      <Typography variant="caption" color="text.secondary" sx={{ fontStyle: "italic", lineHeight: 1.3 }}>
        {buildTypingLabel(typingUsers, t)}
      </Typography>
    </Box>
  );
};

export default TeamTypingIndicator;
